import { formatCurrency, formatTopupNumber } from '@recargas-dominicanas/core/utils';
import type { IProduct } from '@recargas-dominicanas/core/types';
import { DetailModal } from '../detail-modal/detail-modal.component';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';

import {
  ModalContent,
  ModalActions, 
  Button, 
  OutlineButton
} from '@recargas-dominicanas/core/components';

interface Props {
  open: boolean;
  ownerName?: string;
  phone: string;
  amount: number;
  product: IProduct;
  overlayEnterAnimation?: boolean;
  onAccept: () => void;
  onClose: () => void;
}

export function TopupConfirmModal(props: Props) {

  const {
    open,
    product,
    ownerName,
    phone,
    amount,
    overlayEnterAnimation,
    onAccept,
    onClose
  } = props;

  const topupNumber = formatTopupNumber(product, phone);

  return (
    <DetailModal
      open={open}
      title='Confirmar recarga'
      overlayEnterAnimation={overlayEnterAnimation}>
      <ModalContent>
        <DetailModalItem title='Compañía' text={product.name}/>
        {ownerName && <DetailModalItem title='Titular' text={ownerName}/>}
        <DetailModalItem title={topupNumber.title} text={topupNumber.value}/>
        <DetailModalItem title='Monto' text={formatCurrency(amount)} color='green'/>
      </ModalContent>
      <ModalActions>
        <Button text='Cancelar' onClick={onClose}/>
        <OutlineButton text='Aceptar' onClick={onAccept} />
      </ModalActions>
    </DetailModal>
  );
}
